import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import visaService from "./visaService";

const initialState = {
  visas: [],
  visa: null,

  isCreateLoading: false,
  isCreateError: false,
  isCreateSuccess: false,
  createErrorMessage: "",

  isListLoading: false,
  isListError: false,
  isListSuccess: false,
  listErrorMessage: "",

  isDetailsLoading: false,
  isDetailsError: false,
  isDetailsSuccess: false,
  detailsErrorMessage: "",

  isUpdateLoading: false,
  isUpdateError: false,
  isUpdateSuccess: false,
  updateErrorMessage: "",

  isDeleteLoading: false,
  isDeleteError: false,
  isDeleteSuccess: false,
  deleteErrorMessage: "",
};

//Create Visa
export const createVisa = createAsyncThunk(
  "visa/createVisa",
  async (visa, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const createdVisa = await visaService.createVisa(visa, token);
      return createdVisa;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Get All Visas
export const getAllVisas = createAsyncThunk(
  "visa/getAllVisas",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const visas = await visaService.getAllVisas(token);
      return visas;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Get Visa by ID
export const getVisaById = createAsyncThunk(
  "visa/getVisaById",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const visa = await visaService.getVisaById(id, token);
      return visa;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Update Visa
export const updateVisa = createAsyncThunk(
  "visa/updateVisa",
  async ({ id, visa }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const updatedVisa = await visaService.updateVisa(id, visa, token);
      return updatedVisa;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Delete Visa
export const deleteVisa = createAsyncThunk(
  "visa/deleteVisa",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      await visaService.deleteVisa(id, token);
      return id;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const visaSlice = createSlice({
  name: "visa",
  initialState,
  reducers: {
    resetVisaCreate: (state) => {
      state.isCreateLoading = false;
      state.isCreateError = false;
      state.isCreateSuccess = false;
      state.createErrorMessage = "";
    },
    resetVisaList: (state) => {
      state.visas = [];
      state.isListLoading = false;
      state.isListError = false;
      state.isListSuccess = false;
      state.listErrorMessage = "";
    },
    resetVisaDetails: (state) => {
      state.visa = null;
      state.isDetailsLoading = false;
      state.isDetailsError = false;
      state.isDetailsSuccess = false;
      state.detailsErrorMessage = "";
    },
    resetVisaUpdate: (state) => {
      state.isUpdateLoading = false;
      state.isUpdateError = false;
      state.isUpdateSuccess = false;
      state.updateErrorMessage = "";
    },
    resetVisaDelete: (state) => {
      state.isDeleteLoading = false;
      state.isDeleteError = false;
      state.isDeleteSuccess = false;
      state.deleteErrorMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createVisa.pending, (state) => {
        state.isCreateLoading = true;
        state.isCreateError = false;
        state.isCreateSuccess = false;
        state.createErrorMessage = "";
      })
      .addCase(createVisa.fulfilled, (state, action) => {
        state.isCreateLoading = false;
        state.isCreateError = false;
        state.isCreateSuccess = true;
        state.createErrorMessage = "";

        state.visas.push(action.payload);
        state.visa = action.payload;
      })
      .addCase(createVisa.rejected, (state, action) => {
        state.isCreateLoading = false;
        state.isCreateError = true;
        state.isCreateSuccess = false;
        state.createErrorMessage = action.payload;
      })
      .addCase(getAllVisas.pending, (state) => {
        state.isListLoading = true;
        state.isListError = false;
        state.isListSuccess = false;
        state.listErrorMessage = "";
      })
      .addCase(getAllVisas.fulfilled, (state, action) => {
        state.isListLoading = false;
        state.isListError = false;
        state.isListSuccess = true;
        state.listErrorMessage = "";

        state.visas = action.payload;
      })
      .addCase(getAllVisas.rejected, (state, action) => {
        state.isListLoading = false;
        state.isListError = true;
        state.isListSuccess = false;
        state.listErrorMessage = action.payload;
      })
      .addCase(getVisaById.pending, (state) => {
        state.isDetailsLoading = true;
        state.isDetailsError = false;
        state.isDetailsSuccess = false;
        state.detailsErrorMessage = "";
      })
      .addCase(getVisaById.fulfilled, (state, action) => {
        state.isDetailsLoading = false;
        state.isDetailsError = false;
        state.isDetailsSuccess = true;
        state.detailsErrorMessage = "";

        state.visa = action.payload;
      })
      .addCase(getVisaById.rejected, (state, action) => {
        state.isDetailsLoading = false;
        state.isDetailsError = true;
        state.isDetailsSuccess = false;
        state.detailsErrorMessage = action.payload;
      })
      .addCase(updateVisa.pending, (state) => {
        state.isUpdateLoading = true;
        state.isUpdateError = false;
        state.isUpdateSuccess = false;
        state.updateErrorMessage = "";
      })
      .addCase(updateVisa.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
        state.isUpdateError = false;
        state.isUpdateSuccess = true;
        state.updateErrorMessage = "";

        state.visas = state.visas.map((visa) =>
          visa._id === action.payload._id ? action.payload : visa
        );
        state.visa = action.payload;
      })
      .addCase(updateVisa.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.isUpdateError = true;
        state.isUpdateSuccess = false;
        state.updateErrorMessage = action.payload;
      })
      .addCase(deleteVisa.pending, (state) => {
        state.isDeleteLoading = true;
        state.isDeleteError = false;
        state.isDeleteSuccess = false;
        state.deleteErrorMessage = "";
      })
      .addCase(deleteVisa.fulfilled, (state, action) => {
        state.isDeleteLoading = false;
        state.isDeleteError = false;
        state.isDeleteSuccess = true;
        state.deleteErrorMessage = "";

        state.visas = state.visas.filter((visa) => visa._id !== action.payload);
        state.visa = null;
      })
      .addCase(deleteVisa.rejected, (state, action) => {
        state.isDeleteLoading = false;
        state.isDeleteError = true;
        state.isDeleteSuccess = false;
        state.deleteErrorMessage = action.payload;
      });
  },
});

export const {
  resetVisaCreate,
  resetVisaList,
  resetVisaDetails,
  resetVisaUpdate,
  resetVisaDelete,
} = visaSlice.actions;

export default visaSlice.reducer;
